// import {MENU_ITEMS} from "./intems";
import './index.css';
import React, {useEffect, useState} from "react";
import {navigateTo, routes, RouteType} from "../../routes";
import {cache} from "../../global";
import {WaitingWheel} from "../waiting-wheel/waiting-wheel";
import {getMagnitudeFor} from "./menu-service";
import {getLastElementOr, showlog} from "../../utils";
import {checkAuth} from "../../business-logic/login";
import {getAllMagnitudes} from "../../service";



const MENU_ITEMS: RouteType[] =
	routes

		// filtrate tutte le routes di questo menu
		.filter((route: any) => (
			checkAuth() &&
			!(['welcome', 'error', 'login'].includes(route.id)))
		)
;


export const Menu = (props: { targetPage: any; activeMenuItemId: string; }) => {

	const [active, setActive] = useState<string>(props.activeMenuItemId || '');
	const [menuMetaData, setMenuMetaData] = useState<{ id: string; magnitude: number }[]>([]);
	// const [magnitude, setMagnitude] = useState<{ orders: number, logs: number }>({orders: 0, logs: 0});

	useEffect(() => {

		let tempMagnitude = {orders: 0, logs: 0};
		getAllMagnitudes()
			.then(({data}) => tempMagnitude = data)
			.catch(err => showlog('err', err))
			.finally(() => {
				let pre__menuMetaData: { id: string; magnitude: number; }[] = [];
				showlog('tempMagnitude', tempMagnitude);

				MENU_ITEMS
					.map((menuItem: RouteType, index: number) => {
						showlog('menuItem', menuItem);

						let magnitude = 0
						if (menuItem.id === "orders-v2") {
							magnitude = tempMagnitude.orders
						}
						if (menuItem.id === "logs") {
							magnitude = tempMagnitude.logs
						}

						pre__menuMetaData.push({
							id: menuItem.id,
							magnitude: magnitude
						})
					})
				setMenuMetaData(pre__menuMetaData)



				// if (result.status === 'fulfilled') {
				// 	pre__menuMetaData.push({
				// 		id: MENU_ITEMS[resultIndex].id,
				// 		magnitude: result.value.data.reduce(getLastElementOr, {magnitude: 0}).magnitude
				// 	})
				// } else {
				// 	pre__menuMetaData.push({
				// 		id: MENU_ITEMS[resultIndex].id,
				// 		magnitude: 0
				// 	})
				// }
			})

		// Promise.allSettled(MENU_ITEMS.map((menuItem: RouteType, menuIndex: number) => getMagnitudeFor(menuItem.id)))
		// 	.then((results: PromiseSettledResult<any>[]) => {
		//
		// 		let pre__menuMetaData: { id: string; magnitude: number; }[] = [];
		// 		results
		// 			.map((result: PromiseSettledResult<any>, resultIndex: number) => {
		// 				if (result.status === 'fulfilled') {
		// 					pre__menuMetaData.push({
		// 						id: MENU_ITEMS[resultIndex].id,
		// 						magnitude: result.value.data.reduce(getLastElementOr, {magnitude: 0}).magnitude
		// 					})
		// 				} else {
		// 					pre__menuMetaData.push({
		// 						id: MENU_ITEMS[resultIndex].id,
		// 						magnitude: 0
		// 					})
		// 				}
		// 			})
		//
		// 		setMenuMetaData(pre__menuMetaData);
		//
		// 	})
		// 	.catch((e: any) => {
		// 		// TODO
		// 		showlog('PromiseAll error', e);
		// 	})


	}, [])


	showlog('portal main menu', {active, menuMetaData, MENU_ITEMS});


	return (
		<div
			id={'menu'}
			className={
				(!!cache.currentPage && (cache.currentPage.id !== 'welcome'))
					? ' hide'
					: ''
			}
		>
			{
				MENU_ITEMS
					.map((menuItem: RouteType, menuIndex: number) => (
						<div
							key={'menu-item' + menuItem.id}
							className={'menu-item' + ((menuItem.id === active) ? ' active' : '')}
							onClick={clickEvent => {
								clickEvent.stopPropagation();
								clickEvent.preventDefault();
								setActive(menuItem.id);
								props.targetPage(menuItem);
							}}
						>
							<img src={'' + menuItem.icon}/>
							<div>
								<div>{menuItem.label}</div>
								<code>
									{
										`presenti:  ${
											!!menuMetaData[menuIndex]
												? menuMetaData[menuIndex].magnitude
												: ''
										}`
									}
									{
										!!menuMetaData[menuIndex]
											? null
											: (
												<WaitingWheel
													error={false}
													className={'menu-item-wait-wheel'}
													color={'var(--secondary-selection-color)'}
													ray={8}
													strokeWidth={2}
												/>
											)
									}
								</code>
								<span>info</span>
							</div>
						</div>
					))
			}
		</div>
	)
}
